import {
    PAGE_SORT_ORDER,
    PAGE_CONDITION_OPERATOR,
} from 'config/constants';
import Enum from "config/enum";

export const PAGE_FORM_CONFIG = {
    MEMBER: {
        CREATE: {
            ITEMS: {
                "member.authId": "",
                "member.role": Enum.BE_MEMBER_ROLE.SYSTEM_MANAGE,
                "member.name": "",
                "member.password": "",
            },
            REQUEST: ["member.authId", "member.name", "member.password"],
            REQUIRE: ["member.authId", "member.name", "member.password"],
        },
        UPDATE: {
            REQUEST: ["member.authId", "member.name", "member.password"],
            REQUIRE: ["member.authId", "member.name"],
        },
    },
    WATERMARK: {
        CREATE: {
            ITEMS: {
                "watermark.name": "",
                "watermark.width": 100,
                "watermark.height": 100,
                "watermark.opacity": 100,
                "watermark.angle": 0,
                "watermark.page": Enum.FE_WATERMARK_POSITION.ALL,
                "watermark.position": 5,
                "watermarkResource.list": [],
            },
            REQUEST: [
                "watermark.name",
                "watermark.width",
                "watermark.height",
                "watermark.opacity",
                "watermark.angle",
                "watermark.page",
                "watermark.position",
                "watermarkResource.list"
            ],
            REQUIRE: [
                "watermark.name",
                "watermark.width",
                "watermark.height",
                "watermark.opacity",
                "watermark.angle",
                "watermark.page",
                "watermark.position",
                "watermarkResource.list"
            ],
            VALIDATE: {}
        },
        UPDATE: {
            REQUEST: [
                "watermark.name",
                "watermark.width",
                "watermark.height",
                "watermark.opacity",
                "watermark.angle",
                "watermark.page",
                "watermark.position",
                "watermarkResource.list"
            ],
            REQUIRE: [
                "watermark.name",
                "watermark.width",
                "watermark.height",
                "watermark.opacity",
                "watermark.angle",
                "watermark.page",
                "watermark.position",
                "watermarkResource.list"
            ],
            VALIDATE: {},
        },
    },
    VIEW_CONFIG: {
        CREATE: {
            REQUEST: [
                "viewConfig.name",
                // 기능
                "viewConfig.uiFuncPrintEnable",
                "viewConfig.uiFuncDownloadEnable",
                "viewConfig.uiFuncDownloadOriginalFileEnable",
                "viewConfig.uiFuncDownloadResourceFileEnable",
                "viewConfig.uiFuncFullScreenEnable",
                "viewConfig.uiFuncRightClickEnable",
                "viewConfig.uiFuncShortCutEnable",
                "viewConfig.uiFuncTtsEnable",
                "viewConfig.uiFuncHighContrastEnable",
                "viewConfig.uiFuncRotateEnable",
                // UI/UX 제어
                "viewConfig.uiHeaderEnable",
                "viewConfig.uiBottomControlsEnable",
                "viewConfig.uiFindEnable",
                "viewConfig.uiMenuButtonBookEnable",
                "viewConfig.uiMenuButtonInfoEnable",
                "viewConfig.uiInfoDialogProductEnable",
                "viewConfig.uiInfoDialogViewerEnable",
                "viewConfig.uiInfoDialogPdfEnable",
                "viewConfig.uiPanelEnable",
                "viewConfig.uiPanelFileEnable",
                "viewConfig.uiPanelThumbnailEnable",
                "viewConfig.uiPanelOutlineEnable",
                "viewConfig.uiPanelAttachmentEnable",
                "viewConfig.uiViewEnable",
                "viewConfig.uiViewButtonScrollVerticalEnable",
                "viewConfig.uiViewButtonScrollPageEnable",
                "viewConfig.uiViewButtonLayoutSingleEnable",
                "viewConfig.uiViewButtonLayoutMultiEnable",
                "viewConfig.uiViewButtonLayoutCoverEnable",
                "viewConfig.uiViewButtonFullScreenEnable",
                "viewConfig.uiCursorEnable",
                "viewConfig.uiCursorButtonBaseEnable",
                "viewConfig.uiCursorButtonHandEnable",
                "viewConfig.uiShortCutList",
                "viewConfig.uiOpenScreenMode",
                "viewConfig.uiOpenScaleMode",
                "viewConfig.uiOpenPanel"
            ],
            REQUIRE: ["viewConfig.name"],
            MAPPER: {},
        },
        UPDATE: {
            REQUEST: [
                "viewConfig.name",
                // 기능
                "viewConfig.uiFuncPrintEnable",
                "viewConfig.uiFuncDownloadEnable",
                "viewConfig.uiFuncDownloadOriginalFileEnable",
                "viewConfig.uiFuncDownloadResourceFileEnable",
                "viewConfig.uiFuncFullScreenEnable",
                "viewConfig.uiFuncRightClickEnable",
                "viewConfig.uiFuncShortCutEnable",
                "viewConfig.uiFuncTtsEnable",
                "viewConfig.uiFuncHighContrastEnable",
                "viewConfig.uiFuncRotateEnable",
                // UI/UX 제어
                "viewConfig.uiHeaderEnable",
                "viewConfig.uiBottomControlsEnable",
                "viewConfig.uiFindEnable",
                "viewConfig.uiMenuButtonBookEnable",
                "viewConfig.uiMenuButtonInfoEnable",
                "viewConfig.uiInfoDialogProductEnable",
                "viewConfig.uiInfoDialogViewerEnable",
                "viewConfig.uiInfoDialogPdfEnable",
                "viewConfig.uiPanelEnable",
                "viewConfig.uiPanelFileEnable",
                "viewConfig.uiPanelThumbnailEnable",
                "viewConfig.uiPanelOutlineEnable",
                "viewConfig.uiPanelAttachmentEnable",
                "viewConfig.uiViewEnable",
                "viewConfig.uiViewButtonScrollVerticalEnable",
                "viewConfig.uiViewButtonScrollPageEnable",
                "viewConfig.uiViewButtonLayoutSingleEnable",
                "viewConfig.uiViewButtonLayoutMultiEnable",
                "viewConfig.uiViewButtonLayoutCoverEnable",
                "viewConfig.uiViewButtonFullScreenEnable",
                "viewConfig.uiCursorEnable",
                "viewConfig.uiCursorButtonBaseEnable",
                "viewConfig.uiCursorButtonHandEnable",
                "viewConfig.uiShortCutList",
                "viewConfig.uiOpenScreenMode",
                "viewConfig.uiOpenScaleMode",
                "viewConfig.uiOpenPanel"
            ],
            REQUIRE: ["viewConfig.name"],
            MAPPER: {},
        },
    },
    VIEWER: {
        CREATE: {
            REQUEST: [
                "document.list",
                "viewer.name",
                "watermark.list",
                "viewConfig",
                "viewer.expireDate",
                "viewer.limitHitCount",
                "viewer.limitPrintCount",
                "viewer.limitDownloadCount",
            ],
            REQUIRE: [
                "viewer.name",
                "document.list"
            ],
        },
        UPDATE: {
            REQUEST: [
                "viewer.name",
                "watermark.list",
                "viewConfig",
                "viewer.expireDate",
                "viewer.limitHitCount",
                "viewer.limitPrintCount",
                "viewer.limitDownloadCount",
            ],
            REQUIRE: [
                "viewer.name",
                "document.list"
            ],
        },


        BFF_CREATE_FILE: {
            REQUEST: [
                "viewer.name",
                "document.list",
                "watermark.list",
                "viewConfig",
                "viewer.limitHitCount",
                "viewer.limitPrintCount",
                "viewer.limitDownloadCount",
                "viewer.expireDate"
            ],
            REQUIRE: ["viewer.name", "document.list"],
        },
        BFF_CREATE_FILES: {
            REQUEST: ["documents", "externalId", "name", "watermarks", "viewConfig", "limitHitCount", "limitPrintCount", "limitDownloadCount", "expireDate"],
            REQUIRE: ["name", "documents"],
            MAPPER: {},
        },
        BFF_CREATE_ZIP_FILE: {
            REQUEST: ["documents", "externalId", "name", "watermarks", "viewConfig", "limitHitCount", "limitPrintCount", "limitDownloadCount", "expireDate"],
            REQUIRE: ["name", "documents"],
            MAPPER: {},
        },
        BFF_UPDATE: {
            REQUEST: [
                "viewer.name",
                "watermark.list",
                "viewConfig",
                "viewer.limitHitCount",
                "viewer.limitPrintCount",
                "viewer.limitDownloadCount",
                "viewer.expireDate"
            ],
            REQUIRE: ["viewer.name"],
            MAPPER: {},
        },
    },
};

export const PAGE_VIEW_CONFIG = {
    MEMBER: {
        // init
        INIT_PAGE_DATA: {
            view: "",
            order: PAGE_SORT_ORDER.DESC,
            orderBy: "member.createdDate",
            period: null,
            page: 0,
            size: 10,

            condition: {
                "id": "root",
                "clause": {
                    "key": "member.authId",
                    "value": "",
                    "operator": PAGE_CONDITION_OPERATOR.EQUAL
                },
                "children": null,
                "connector": null,
            }
        },

        // func
        FUNC: {
            IS_ACTION: true,
            IS_VIEW: false,
            IS_SEARCH_ADVANCE: false,
            IS_SEARCH_CONDITION: true,
        },

        // search
        SORT_KEYS: [
            "member.authId",
            "member.name",
            "member.createdDate",
            "member.updatedDate",
        ],
        PERIOD_KEYS: [
            "member.createdDate",
            "member.updatedDate",
        ],
        CONDITION_KEYS: [
            "member.authId",
            "member.name"
        ],
        BASE_CONDITIONS: [],

        TABLES: {
            DEFAULT: [
                {key: "empty", size: 14},
                {key: "empty", size: 36},
                {key: "checkbox", size: 38},
                {key: "empty", size: 58},
                {key: "member.role", size: 78},
                {key: "empty", size: 108},
                {key: "member.authId", size: 140, align: "left"},
                {key: "empty", size: 136},
                {key: "member.name", size: 180, align: "left"},
                {key: "empty", size: 111},
                {key: "function", size: 160},
                {key: "empty", size: 92},
                {key: "member.createdDate", size: 147},
                {key: "empty", size: 64},
                {key: "member.updatedDate", size: 147},
                {key: "empty", size: 36},
                {key: "empty", size: 14},
            ],
            DESKTOP: [
                {key: "empty", size: 14},
                {key: "checkbox", size: 38},
                {key: "empty", size: 35},
                {key: "member.role", size: 78},
                {key: "empty", size: 50},
                {key: "member.authId", size: 140, align: "left"},
                {key: "empty", size: 49},
                {key: "member.name", size: 180, align: "left"},
                {key: "empty", size: 36},
                {key: "function", size: 160},
                {key: "empty", size: 30},
                {key: "member.createdDate", size: 147},
                {key: "empty", size: 33},
                {key: "member.updatedDate", size: 147},
                {key: "empty", size: 14},
            ],
            LAPTOP: [
                {key: "empty", size: 14},
                {key: "checkbox", size: 38},
                {key: "empty", size: 12},
                {key: "member.role", size: 78},
                {key: "empty", size: 15},
                {key: "member.authId", size: 140, align: "left"},
                {key: "empty", size: 18},
                {key: "member.name", size: 180, align: "left"},
                {key: "empty", size: 15},
                {key: "function", size: 160},
                {key: "empty", size: 20},
                {key: "member.updatedDate", size: 147},
                {key: "empty", size: 14},
            ],
            TABLET: [
                {key: "empty", size: 14},
                {key: "checkbox", size: 38},
                {key: "empty", size: 21},
                {key: "member.authId", size: 140, align: "left"},
                {key: "empty", size: 21},
                {key: "member.name", size: 180, align: "left"},
                {key: "empty", size: 8},
                {key: "function", size: 160},
                {key: "empty", size: 14},
            ],
        }
    },
    DOCUMENT: {
        // init
        INIT_PAGE_DATA: {
            view: "",
            order: PAGE_SORT_ORDER.DESC,
            orderBy: "document.createdDate",
            period: null,
            page: 0,
            size: 10,

            condition: {
                "id": "root",
                "clause": {
                    "key": "document.name",
                    "value": "",
                    "operator": PAGE_CONDITION_OPERATOR.CONTAINS
                },
                "children": null,
                "connector": null,
            }
        },

        // func
        FUNC: {
            IS_ACTION: true,
            IS_VIEW: false,
            IS_SEARCH_ADVANCE: false,
            IS_SEARCH_CONDITION: true,
        },

        // search
        SORT_KEYS: [
            "document.id",
            "document.name",
            "document.createdDate",
            "document.updatedDate",
        ],
        PERIOD_KEYS: [
            "document.createdDate",
            "document.updatedDate",
        ],
        CONDITION_KEYS: [
            "document.name",
            "document.id"
        ],
        BASE_CONDITIONS: [],

        TABLES: {
            DEFAULT: [
                {key: "empty", size: 14},
                {key: "empty", size: 36},
                {key: "checkbox", size: 38},
                {key: "empty", size: 19},
                {key: "document.status", size: 100},
                {key: "empty", size: 9},
                {key: "document.fileFormat", size: 100},
                {key: "empty", size: 95},
                {key: "document.name", size: 286, align: "left"},
                {key: "empty", size: 24},
                {key: "document.id", size: 170, align: "left"},
                {key: "empty", size: 83},
                {key: "function", size: 160},
                {key: "empty", size: 34},
                {key: "document.createdDate", size: 147},
                {key: "empty", size: 46},
                {key: "document.updatedDate", size: 147},
                {key: "empty", size: 36},
                {key: "empty", size: 14},
            ],
            DESKTOP: [
                {key: "empty", size: 14},
                {key: "checkbox", size: 38},
                {key: "empty", size: 16},
                {key: "document.status", size: 100},
                {key: "empty", size: 14},
                {key: "document.fileFormat", size: 100},
                {key: "empty", size: 14},
                {key: "document.name", size: 170, align: "left"},
                {key: "empty", size: 23},
                {key: "document.id", size: 170, align: "left"},
                {key: "function", size: 160},
                {key: "document.createdDate", size: 147},
                {key: "document.updatedDate", size: 147},
                {key: "empty", size: 14},
            ],
            LAPTOP: [
                {key: "empty", size: 14},
                {key: "checkbox", size: 38},
                {key: "empty", size: 7},
                {key: "document.status", size: 100},
                {key: "empty", size: 14},
                {key: "document.fileFormat", size: 100},
                {key: "empty", size: 8},
                {key: "document.name", size: 170, align: "left"},
                {key: "empty", size: 23},
                {key: "document.id", size: 170, align: "left"},
                {key: "empty", size: 26},
                {key: "function", size: 160},
                {key: "empty", size: 14},
            ],
            TABLET: [
                {key: "empty", size: 14},
                {key: "empty", size: 16},
                {key: "checkbox", size: 38},
                {key: "empty", size: 19},
                {key: "document.status", size: 100},
                {key: "empty", size: 16},
                {key: "document.fileFormat", size: 100},
                {key: "empty", size: 51},
                {key: "document.name", size: 170, align: "left"},
                {key: "empty", size: 56},
                {key: "empty", size: 14},
            ],
        }
    },
    WATERMARK: {
        // init
        INIT_PAGE_DATA: {
            view: "",
            order: PAGE_SORT_ORDER.DESC,
            orderBy: "watermark.createdDate",
            period: null,
            page: 0,
            size: 10,

            condition: {
                "id": "root",
                "clause": {
                    "key": "watermark.name",
                    "value": "",
                    "operator": PAGE_CONDITION_OPERATOR.CONTAINS
                },
                "children": null,
                "connector": null,
            }
        },

        // func
        FUNC: {
            IS_ACTION: true,
            IS_VIEW: false,
            IS_SEARCH_ADVANCE: false,
            IS_SEARCH_CONDITION: true,
        },

        // search
        SORT_KEYS: [
            "watermark.id",
            "watermark.name",
            "watermark.createdDate",
            "watermark.updatedDate",
        ],
        PERIOD_KEYS: [
            "watermark.createdDate",
            "watermark.updatedDate",
        ],
        CONDITION_KEYS: [
            "watermark.name",
            "watermark.id"
        ],
        BASE_CONDITIONS: [],

        TABLES: {
            DEFAULT: [
                {key: "empty", size: 14},
                {key: "empty", size: 36},
                {key: "checkbox", size: 38},
                {key: "empty", size: 53},
                {key: "watermark.name", size: 286, align: "left"},
                {key: "empty", size: 36},
                {key: "watermark.id", size: 286, align: "left"},
                {key: "empty", size: 113},
                {key: "function", size: 160},
                {key: "empty", size: 112},
                {key: "watermark.createdDate", size: 147},
                {key: "empty", size: 80},
                {key: "watermark.updatedDate", size: 147},
                {key: "empty", size: 36},
                {key: "empty", size: 14},
            ],
            DESKTOP: [
                {key: "empty", size: 14},
                {key: "checkbox", size: 38},
                {key: "empty", size: 8},
                {key: "watermark.name", size: 286, align: "left"},
                {key: "watermark.id", size: 286, align: "left"},
                {key: "function", size: 160},
                {key: "empty", size: 20},
                {key: "watermark.createdDate", size: 147},
                {key: "empty", size: 20},
                {key: "watermark.updatedDate", size: 147},
                {key: "empty", size: 8},
                {key: "empty", size: 14},
            ],
            LAPTOP: [
                {key: "empty", size: 14},
                {key: "checkbox", size: 38},
                {key: "empty", size: 30},
                {key: "watermark.name", size: 170, align: "left"},
                {key: "empty", size: 23},
                {key: "watermark.id", size: 170, align: "left"},
                {key: "empty", size: 26},
                {key: "function", size: 160},
                {key: "empty", size: 26},
                {key: "watermark.updatedDate", size: 147},
                {key: "empty", size: 26},
                {key: "empty", size: 14},
            ],
            TABLET: [
                {key: "empty", size: 14},
                {key: "checkbox", size: 38},
                {key: "empty", size: 15},
                {key: "watermark.name", size: 170, align: "left"},
                {key: "empty", size: 4},
                {key: "watermark.id", size: 170, align: "left"},
                {key: "empty", size: 4},
                {key: "function", size: 160},
                {key: "empty", size: 14},
            ],
        }
    },
    VIEW_CONFIG: {
        // init
        INIT_PAGE_DATA: {
            view: "",
            order: PAGE_SORT_ORDER.DESC,
            orderBy: "viewConfig.createdDate",
            period: null,
            page: 0,
            size: 10,

            condition: {
                "id": "root",
                "clause": {
                    "key": "viewConfig.name",
                    "value": "",
                    "operator": PAGE_CONDITION_OPERATOR.CONTAINS
                },
                "children": null,
                "connector": null,
            }
        },

        // func
        FUNC: {
            IS_ACTION: true,
            IS_VIEW: false,
            IS_SEARCH_ADVANCE: false,
            IS_SEARCH_CONDITION: true,
        },

        // search
        SORT_KEYS: [
            "viewConfig.id",
            "viewConfig.name",
            "viewConfig.createdDate",
            "viewConfig.updatedDate",
        ],
        PERIOD_KEYS: [
            "viewConfig.createdDate",
            "viewConfig.updatedDate",
        ],
        CONDITION_KEYS: [
            "viewConfig.name",
            "viewConfig.id"
        ],
        BASE_CONDITIONS: [],

        TABLES: {
            DEFAULT: [
                {key: "empty", size: 14},
                {key: "empty", size: 36},
                {key: "checkbox", size: 38},
                {key: "empty", size: 53},
                {key: "viewConfig.name", size: 286, align: "left"},
                {key: "empty", size: 36},
                {key: "viewConfig.id", size: 286, align: "left"},
                {key: "empty", size: 113},
                {key: "function", size: 160},
                {key: "empty", size: 112},
                {key: "viewConfig.createdDate", size: 147},
                {key: "empty", size: 80},
                {key: "viewConfig.updatedDate", size: 147},
                {key: "empty", size: 36},
                {key: "empty", size: 14},
            ],
            DESKTOP: [
                {key: "empty", size: 14},
                {key: "checkbox", size: 38},
                {key: "empty", size: 8},
                {key: "viewConfig.name", size: 286, align: "left"},
                {key: "viewConfig.id", size: 286, align: "left"},
                {key: "function", size: 160},
                {key: "empty", size: 20},
                {key: "viewConfig.createdDate", size: 147},
                {key: "empty", size: 21},
                {key: "viewConfig.updatedDate", size: 147},
                {key: "empty", size: 8},
                {key: "empty", size: 14},
            ],
            LAPTOP: [
                {key: "empty", size: 14},
                {key: "checkbox", size: 38},
                {key: "empty", size: 30},
                {key: "viewConfig.name", size: 170, align: "left"},
                {key: "empty", size: 23},
                {key: "viewConfig.id", size: 170, align: "left"},
                {key: "empty", size: 26},
                {key: "function", size: 160},

                {key: "viewConfig.updatedDate", size: 147},
                {key: "empty", size: 12},
                {key: "empty", size: 14},
            ],
            TABLET: [
                {key: "empty", size: 14},
                {key: "checkbox", size: 38},
                {key: "empty", size: 15},
                {key: "viewConfig.name", size: 170, align: "left"},
                {key: "empty", size: 4},
                {key: "viewConfig.id", size: 170, align: "left"},
                {key: "empty", size: 6},
                {key: "function", size: 160},
                {key: "empty", size: 14},
            ],
        }
    },
    VIEWER: {
        // init
        INIT_PAGE_DATA: {
            view: "",
            order: PAGE_SORT_ORDER.DESC,
            orderBy: "viewer.createdDate",
            period: null,
            page: 0,
            size: 10,

            condition: {
                "id": "root",
                "clause": {
                    "key": "viewer.name",
                    "value": "",
                    "operator": PAGE_CONDITION_OPERATOR.CONTAINS
                },
                "children": null,
                "connector": null,
            }
        },

        // func
        FUNC: {
            IS_ACTION: true,
            IS_VIEW: false,
            IS_SEARCH_ADVANCE: false,
            IS_SEARCH_CONDITION: true,
        },

        // search
        SORT_KEYS: [
            "viewer.id",
            "viewer.name",
            "viewer.createdDate",
            "viewer.updatedDate",
            "viewer.expireDate",
        ],
        PERIOD_KEYS: [
            "viewer.createdDate",
            "viewer.updatedDate",
            "viewer.expireDate",
        ],
        CONDITION_KEYS: [
            "viewer.name",
            "viewer.id",
            "viewer.status",
            "viewer.type",
        ],
        BASE_CONDITIONS: [],

        TABLES: {
            DEFAULT: [
                {key: "empty", size: 14},
                {key: "checkbox", size: 38},
                {key: "viewer.status", size: 91},
                {key: "empty", size: 17},
                {key: "viewer.type", size: 78},
                {key: "empty", size: 23},
                {key: "viewer.info", size: 231, align: "left"},
                {key: "empty", size: 45},
                {key: "viewer.name", size: 220, align: "left"},
                {key: "empty", size: 23},
                {key: "viewer.id", size: 170, align: "left"},
                {key: "empty", size: 50},
                {key: "function", size: 160},
                {key: "empty", size: 36},
                {key: "viewer.createdDate", size: 147},
                {key: "empty", size: 36},
                {key: "viewer.updatedDate", size: 147},
                {key: "empty", size: 18},
                {key: "empty", size: 14},
            ],
            DESKTOP: [
                {key: "empty", size: 14},
                {key: "checkbox", size: 38},
                {key: "viewer.status", size: 91},
                {key: "empty", size: 11},
                {key: "viewer.type", size: 78},
                {key: "empty", size: 23},
                {key: "viewer.info", size: 231, align: "left"},
                {key: "empty", size: 41},
                {key: "viewer.name_id", size: 220, align: "left"},
                {key: "empty", size: 49},
                {key: "function", size: 160},
                {key: "empty", size: 13},
                {key: "viewer.createdDate", size: 147},
                {key: "empty", size: 19},
                {key: "empty", size: 14},
            ],
            LAPTOP: [
                {key: "empty", size: 14},
                {key: "checkbox", size: 38},
                {key: "viewer.status", size: 91},
                {key: "viewer.type", size: 78},
                {key: "viewer.info", size: 231, align: "left"},
                {key: "empty", size: 3},
                {key: "viewer.name_id", size: 220, align: "left"},
                {key: "function", size: 160},
                {key: "empty", size: 14},
            ],
            TABLET: [
                {key: "empty", size: 14},
                {key: "checkbox", size: 38},
                {key: "empty", size: 11},
                {key: "viewer.status", size: 91},
                {key: "empty", size: 21},
                {key: "viewer.name_id", size: 220, align: "left"},
                {key: "empty", size: 23},
                {key: "function", size: 160},
                {key: "empty", size: 14},
            ],
        }
    },

    SYSTEM_LOG: {
        // init
        INIT_PAGE_DATA: {
            view: "",
            order: PAGE_SORT_ORDER.DESC,
            orderBy: "log.fileName",
            period: null,
            page: 0,
            size: 10,

            condition: {
                "id": "root",
                "clause": {
                    "key": "log.fileName",
                    "value": "",
                    "operator": PAGE_CONDITION_OPERATOR.CONTAINS
                },
                "children": null,
                "connector": null,
            }
        },

        // func
        FUNC: {
            IS_ACTION: true,
            IS_VIEW: false,
            IS_SEARCH_ADVANCE: false,
            IS_SEARCH_CONDITION: true,
        },

        // search
        SORT_KEYS: [
            "log.fileName",
            "log.length",
        ],
        PERIOD_KEYS: [],
        CONDITION_KEYS: [
            "log.fileName",
        ],
        BASE_CONDITIONS: [],

        TABLES: {
            DEFAULT: [
                {key: "empty", size: 14},
                {key: "empty", size: 70},
                {key: "checkbox", size: 38},
                {key: "empty", size: 144},
                {key: "log.fileName", size: 286, align: "left"},
                {key: "empty", size: 677},
                {key: "log.length", size: 286, align: "left"},
                {key: "empty", size: 28},
                {key: "empty", size: 14},
            ],
            DESKTOP: [
                {key: "empty", size: 14},
                {key: "empty", size: 32},
                {key: "checkbox", size: 38},
                {key: "empty", size: 144},
                {key: "log.fileName", size: 286, align: "left"},
                {key: "empty", size: 307},
                {key: "log.length", size: 286, align: "left"},
                {key: "empty", size: 28},
                {key: "empty", size: 14},
            ],
            LAPTOP: [
                {key: "empty", size: 14},
                {key: "checkbox", size: 38},
                {key: "empty", size: 63},
                {key: "log.fileName", size: 286, align: "left"},
                {key: "empty", size: 121},
                {key: "log.length", size: 286, align: "left"},
                {key: "empty", size: 27},
                {key: "empty", size: 14},
            ],
            TABLET: [
                {key: "empty", size: 14},
                {key: "checkbox", size: 38},
                {key: "log.fileName", size: 286, align: "left"},
                {key: "empty", size: 51},
                {key: "log.length", size: 170, align: "left"},
                {key: "empty", size: 21},
                {key: "empty", size: 14},
            ],
        }
    },
};
